import type { LoaderFunctionArgs } from "@remix-run/node";
import { json, redirect } from "@remix-run/node";
import { getAuthenticatedUser } from "~/services/auth.server";
import { Outlet, useLoaderData } from "@remix-run/react";
import PageWithNavigation from "~/components/PageWithNavigation";

export async function loader({ request }: LoaderFunctionArgs) {
  const countryCodeHeader = request.headers.get("CF-IPCountry") || "US";
  const url = new URL(request.url);
  const user = await getAuthenticatedUser(request);

  if (url.pathname === "/privacy-policy") {
    return redirect(`/privacy-policy/${countryCodeHeader}`);
  }

  return json({ user });
}

export default function PrivacyPolicy() {
  const { user } = useLoaderData<typeof loader>();
  return (
    <PageWithNavigation user={user}>
      <Outlet />
    </PageWithNavigation>
  );
}
